import { useTranslation } from "react-i18next";

export default function Main(){
    const { t } = useTranslation();

    const handleinstagram = () => {
        window.open("https://www.instagram.com/adoro_jeans/", "_blank");
    };
    const handlefacebook=()=>{
        window.open("https://www.facebook.com/adorojeans", "_blank");
    }
    const wppsas = ()=>{
        window.location.href = `https://api.whatsapp.com/send?phone=5546991085008&text=oi`;
    }
    const wppcapa = ()=>{
        window.location.href = `https://api.whatsapp.com/send?phone=5546991065008&text=oi`;
    }
    const wpprea = ()=>{
        window.location.href = `https://api.whatsapp.com/send?phone=5546991095008&text=oi`;
    }

    return(
        <div className="main">
            <div className="z-[999] h-full md:w-[50%] w-[100%] max-w-[500px] ml-[8%]">
                <div className="logo h-[600px]"></div>
                <div className="flex justify-evenly w-full">
                    <button onClick={handleinstagram}>
                        <div className="imginstagram h-36 w-36"/>
                    </button>
                    <button onClick={handlefacebook}>
                        <div className="imgfacebook h-36 w-36"/>
                    </button>
                </div>
                <div className="text-white grid place-items-center text-3xl"> {t('fale')} </div>
                <div className="flex justify-evenly">
                    <button onClick={wppsas}>
                        <div className="imgsas h-28 w-28"/>
                    </button>
                    <button onClick={wpprea}>
                        <div className="imgrea h-28 w-28"/>
                    </button>
                    <button onClick={wppcapa}>
                        <div className="imgcapa h-28 w-28"/>
                    </button>
                </div>
                <div className="flex justify-between text-white ml-3">
                    <div> Fone: (46)3563-3854 </div>
                    <div> Email: adorojeans@gmail.com </div>
                </div>
                <div className="flex justify-between text-white ml-3 mt-4">
                    <div className="text-2xl grid place-items-center"> Lojas: </div>
                    <div> 
                        <div> Santo Antônio do Sudoeste: Av. Brasil n° 1796 </div>
                        <div> Realeza: Rua Arnaldo Busato n° 3260 </div>
                        <div> Capanema: Av. Brasil n° 727 </div>
                    </div>
                </div>
            </div>
        </div>
    )
}